<template>
  <button type="submit" class="btn btn-primary" :disabled="loading">
    <span v-if="loading" class="spinner-border spinner-border-sm me-3" role="status"
      aria-hidden="true"></span>
    {{ title }}
  </button>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'SubmitBtn',
  props: {
    title: String,
    loading: Boolean
  },
});
</script>